<template>

    <footer class="bg-light mt-4 py-5">
        <div class="container">

            <div class="row gx-5" v-if="$page.props.app.theme == 'dentagen'">

                <div class="col-sm-8">
                    <div class="h4 mb-5 section-heading">
                        {{ __('Ihr Kontakt zu uns') }}
                    </div>

                    <div class="row gx-5">
                        <div class="col-sm-4">
                            <div class="text-secondary">
                                DENTAGEN Wirtschaftsverbund eG<br />
                                Landabsatz 10<br />
                                45731 Waltrop
                                <br />
                                <br />
                                Telefon	02309 784 70 0<br />
                                Freecall	0800 DENTAGEN<br />
                                Fax		02309 784 70 15<br />
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <ul class="list-unstyled fw-bold lh-lg">
                                <li>
                                    <inertia-link href="/faq">
                                        {{ __('FAQ') }}
                                    </inertia-link>
                                </li>
                                <li>
                                    <inertia-link :href="route('contact')">
                                        {{ __('Support') }}
                                    </inertia-link>
                                </li>
                                <li>
                                    <a :href="route('docs.index')">
                                        {{ __('Dokumentation') }}
                                    </a>
                                </li>
                                <li>
                                    <inertia-link :href="route('terms.supplier')">
                                        {{ __('AGB für Lieferanten') }}
                                    </inertia-link>
                                </li>
                                <li>
                                    <inertia-link :href="route('terms.customer')">
                                        {{ __('AGB für Kunden') }}
                                    </inertia-link>
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-4">
                            <ul class="list-unstyled fw-bold lh-lg">
                                <li>
                                    <a href="https://www.dentagen.de" target="_blank">
                                        {{ __('DENTAGEN Website') }}
                                        <i class="bi bi-arrow-up-right"></i>
                                    </a>
                                </li>
                                <li>
                                    <inertia-link :href="route('contact')">
                                        {{ __('Kontakt') }}
                                    </inertia-link>
                                </li>
                                <li>
                                    <inertia-link :href="route('product-request')">
                                        {{ __('Produktanfrage') }}
                                    </inertia-link>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

                <div class="col-sm-4">
                    <div class="h4 mb-5 section-heading">
                        {{ __('Folgen Sie uns') }}
                    </div>
                    <div class="">
                        <ul class="list-inline fs-2">
                            <li class="list-inline-item">
                                <a href="https://www.linkedin.com/company/dentagen/" target="_blank">
                                    <i class="bi bi-linkedin"></i>
                                </a>
                            </li>
                            <li class="list-inline-item">
                                <a href="https://www.facebook.com/dentagen" target="_blank">
                                    <i class="bi bi-facebook"></i>
                                </a>
                            </li>
                            <!--                                <li class="list-inline-item">
                                                                <a href="#!" target="_blank">
                                    <i class="bi bi-twitter"></i>
                                </a>
                                                            </li>-->
                            <li class="list-inline-item">
                                <a href="https://www.instagram.com/dentagen_wirtschaftsverbund/" target="_blank">
                                    <i class="bi bi-instagram"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>

            <div class="py-5">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <inertia-link :href="route('contact')" class="link-secondary">
                            {{ __('Kontakt') }}
                        </inertia-link>
                    </li>
                    <li class="list-inline-item">
                        <inertia-link href="/impressum" class="link-secondary">
                            {{ __('Impressum') }}
                        </inertia-link>
                    </li>
                    <li class="list-inline-item">
                        <inertia-link href="/datenschutz" class="link-secondary">
                            {{ __('Datenschutz') }}
                        </inertia-link>
                    </li>
                </ul>
                <div class="text-black small" v-if="$page.props.app.theme == 'dentagen'">
                    {{ __('Copyright © :year DENTAGEN Wirtschaftsverbund eG', {year: new Date().getFullYear()}) }}
                </div>
            </div>
        </div>
    </footer>

</template>


<script>


    export default {
        props: [
        ],
        data() {
            return {

            }
        },
        components: {

        },
    }
</script>